import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAddazfkAX4bVQ5Usoik20_DvjwLRUfpSg",
  authDomain: "daily-herald-bb882.firebaseapp.com",
  projectId: "daily-herald-bb882",
  storageBucket: "", // leave empty
  messagingSenderId: "171120067510",
  appId: "1:171120067510:web:9c67bbc7203a0b8ad67717"
};



const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;